import { Link } from "react-router-dom";
import { Hourglass } from "@phosphor-icons/react";

export default function PendingApproval() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0C] p-8">
      <div className="max-w-lg w-full brutal-card p-10 relative overflow-hidden">
        <div className="caution-stripes absolute top-0 left-0 right-0 h-1" />
        <div className="w-14 h-14 bg-[#FFD700] flex items-center justify-center mb-6">
          <Hourglass weight="bold" size={28} className="text-black" />
        </div>
        <div className="font-mono text-xs text-[#FFD700] tracking-widest mb-2">// STATUS: PENDING</div>
        <h1 className="font-display font-black text-3xl md:text-4xl mb-3">AWAITING APPROVAL</h1>
        <p className="text-[#A1A1AA] mb-6">
          Your account request has been submitted. An admin will review it shortly. Once approved, you'll be able to sign in and access the tools inventory.
        </p>
        <Link
          to="/login"
          className="brutal-btn inline-block bg-[#FF4F00] hover:bg-[#FF6B2B] text-black px-5 py-3 transition-colors duration-150"
        >
          ← Back to Sign In
        </Link>
      </div>
    </div>
  );
}
